import React from 'react'
import { useState, useEffect, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Popover, OverlayTrigger} from 'react-bootstrap';
import getCookie from '../../../partials/cookie';
import { Errors } from '../../../partials/Partials'
import { convertPrice } from '../../../functions/Functions';
import { LoadingContext } from '../../../partials/Context';

function Payments({services, payment_data, id, has_recurring_payment_on, getLawyerData, setPaymentTurnedOff}) {
  let list = [];
  let order_type = {
    Month: 6,
    Half: 4, 
    Full: 5
  }
  let basic_service = {};

  const csrftoken = getCookie('csrftoken')
  const {name, address_street, address_post_code, address_city, nip}= payment_data || ''
  

  const [useWallet, setUseWallet] = useState(false);
  const [chosenService, setChosenService] = useState(null);
  const [coupon_code, setCoupon] = useState('');
  const [errors1, setErrors1] =useState([])
  const [errors2, setErrors2] =useState([])
  const [service_price, setServicePrice] = useState(null)
  const [discount_text, setDiscountText] = useState('')
  const {setLoading} = useContext(LoadingContext)
  const [coupon_response, setCouponResponse] = useState([])
  const [radio_check, setRadioCheck] = useState([false, false, false])
  
  useEffect( () => {
    services.forEach(service => {
      const {service_type, price} = service ||'';
      if (service_type === chosenService) {
        setServicePrice(price)
      }
      setErrors1([])
      setErrors2([])
      setDiscountText('')
    })
  }, [services, chosenService])

  useEffect(() => {
    checkPromotions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coupon_response, chosenService])

  if (services) {
    services.forEach((service, index) => {
        const {name, price, service_type, months} = service || '';
        const {price: basic_price} = basic_service || '';

          if (service_type === order_type['Month']) {
            basic_service = service
            list.push(
              <div className="radio-subscription-group" key={index}>
                <label>
                <input readOnly type="radio" id="subscription-month" name="subscription-month" value="subscription-month" onClick={()=> {
                  let newArr = [];
                  services.forEach(service => {
                    newArr.push(false)
                  })
                  newArr[index] = !radio_check[index]
                  setRadioCheck(newArr)
                  setChosenService(service_type)
                }} checked={radio_check[index]}/>
                Wybieram {name} cena: {convertPrice(price/100)} zł brutto (płatność cykliczna comiesięczna)
                </label>
              </div>
            )
          } else {
            list.push(
              <div className="radio-subscription-group" key={index}>
                <label>
                <input readOnly type="radio" id="subscription-month" name="subscription-month" value="subscription-month" onClick={()=>{
                  let newArr = [];
                  services.forEach(service => {
                    newArr.push(false)
                  })
                  newArr[index] = !radio_check[index]
                  setRadioCheck(newArr)
                  setChosenService(service_type)
                
                }} checked={radio_check[index]}/>
                {name} <span style={{textDecoration: 'line-through'}}>{convertPrice(basic_price*months/100)} zł
                </span>&nbsp;cena promocyjna: {convertPrice(price/100)} zł brutto
                </label>
              </div>
            )
          }
        }
      )
  }

  const pay = (e) => {
    const {valid} = coupon_response || ''
    let ecoupon = coupon_code && valid ? `${coupon_code}` : null;
    e.preventDefault()
    if (chosenService) {
      setLoading(true)
    fetch('/api/przelewy24/lawyer-services/process/', {
        method:'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
              ecoupon,
              available_services: services,
              nip: nip,
              p24_address: address_street, 
              p24_amount: service_price,
              p24_city: address_city,
              p24_client: name,
              p24_zip: address_post_code,
              use_wallet: useWallet,
              shopping_cart: [{
                service_type: chosenService,
                quantity: 1
              }]
            })
    }).then(res => {
      if (res.ok) {
        res.json().then(data => {
          const {url_using_wallet} = data || '';
          if (url_using_wallet) {
            window.location = url_using_wallet
          }
        })
      } else {
        res.json().then(data => {
          setErrors1(['Wypełnij dane do faktury'])
        })
    }
    setLoading(false)
    })
    } else {
      setErrors1(['Należy wybrać co najmniej jedną usługę.'])
    } 
  }

  const submitCoupon = (e) => {
    e.preventDefault()
    fetch('/api/przelewy24/lawyer-services/check_coupon/', {
      method:'POST',
        headers: {
          'Content-Type': 'application/json',
          "X-CSRFToken": csrftoken
        },
        body: JSON.stringify({
          code: coupon_code
        })
    }).then(res => {
      if(res.ok) {
        setErrors2([])
        res.json().then(data => {
          const {valid, error, promotions} = data || ''
          if (valid) {
            const {service_nb} = promotions[0] || ''
            setCouponResponse(data);
            setChosenService(service_nb);
            let newArr = [];
            services.forEach(service => {
              newArr.push(false)
            })
            let index = null
            Object.keys(order_type).forEach((type, i) => {
              if (service_nb === order_type[type]) {
                index = i
              }
            })
            newArr[index] = true;
            setRadioCheck(newArr);
          } else {
            setErrors2([error])
          } 
          
          if (error) {
            console.log(error)
          }
        })
      } else {
        setErrors2(['Nie udało się wysłać kodu'])
      }
    })
  }
  
  const PopoverComponent = () => {
    return(
        <Popover id="popover-basic">
        <Popover.Body>
            <h5>Kody rabatowe</h5>
            <span style={{color: '#2f8dbb'}}>Kody rabatowe </span>to ciąg znaków alfanumerycznych o maksymalnej długości pięciu znaków (np. 12abc), które prawnik może wykorzystać, aby zaoszczędzić na usługach oferowanych przez serwis dla prawników.
    </Popover.Body>
  </Popover>
    )
}

const changeRecurringPayment = () => {
  fetch(`/api/lawyer_recurring_payment/${id}/`, {
    method:'PUT',
        headers: {
          'Content-Type': 'application/json',
          "X-CSRFToken": csrftoken
        },
        body: JSON.stringify({
          has_recurring_payment_on: false
        })
  }).then(res => {
    if (res.ok) {
      getLawyerData()
      setPaymentTurnedOff(true)
    } else {
      setErrors1(['Nie udało się wyłączyć płatności cyklicznej kartą'])
    }
  })
}

const checkPromotions = () => {
  let old_price = null
  services.forEach(service => {
    const {service_type, price} = service || '';
    if (chosenService === service_type) {
      old_price = price
    } 
  })
  
  let discount_str = `(${convertPrice(old_price/100)} - `
  let status = false
  let promotions = [];
  
  const {promotions: promotions_list} = coupon_response || ''
  if (promotions_list)
  promotions_list.forEach(promotion => {
    const {service_nb, service_new_price} = promotion || ''
    services.forEach(service => {
      const {service_type, name} = service || ''
      if (service_type === service_nb) {
        promotions.push(name)
      }
    })
    
    if (chosenService === service_nb) {
        status = true
        setServicePrice(service_new_price)
        discount_str += `${convertPrice(old_price/100-service_new_price/100)})`
        setDiscountText(discount_str)
    }
  })

  const {valid} = coupon_response || ''
  if (status === false && coupon_code !== '' && valid) {
    setErrors2([`Wpisany kod obowiązuje na usługę ${promotions.join(', ')}`])
  }
}

  return (
    <div className="payments">
      <h3 className="title title-thin">Płatności abonamentowe</h3>
      <hr />
      <div className="description">
        Konto Premium m.in.:
        <ul>
          <li>zapewni Ci wysoką pozycję w wynikach wyszukiwania w naszym serwisie jak i wyszukiwarkach zewnętrznych</li>
          <li>odkrywa klientowi pełne dane Twojej kancelarii (adres, numer telefonu, stronę www)</li>
          <li>umożliwia odpowiadanie na pytania klientów oraz umawianie wizyt i zakup Twoich usług</li>
        </ul>
        Konto PREMIUM to dodatkowe opcje stwarzające dużo większe możliwości pozyskania klientów w serwisie.
      </div>
      {has_recurring_payment_on === false ? 
      <form>
        {list}
        <div className="button-use-wallet">
          <button onClick={(e) => pay(e)} className="btn btn-blue btn-payment">Przejdź do płatności</button>
          <div className="use-wallet-checkbox">
            <input type="checkbox" id="use-wallet" name="use-wallet" value={useWallet} onChange={()=>setUseWallet(value=>!value)}/>
            <label htmlFor="use-wallet">Użyj środków z portfela </label>
          </div>
        </div>
        <Errors errors={errors1} small={true} />
        <hr />
        <div className="discount">
          <div className="form-coupon">
          <label htmlFor="discount">Kod rabatowy</label>
          <input type="text" id="discount" name="discount" placeholder='wpisz kod' value={coupon_code}onChange={e => setCoupon(e.target.value)}/>
          <button onClick={(e)=>submitCoupon(e)} className="btn btn-blue btn-discount">Użyj kodu</button>
          </div>
          <div className="sum">
            <span>Razem: </span>
            <span className="price"><span>{service_price ? convertPrice(service_price/100) :'0,00'}</span><span>&nbsp;zł</span></span>
            <span className="discount-text">{discount_text}
            </span>
          </div>
        </div>
        <span>
          <Errors small={true} errors={errors2}/>
          <OverlayTrigger trigger={["hover", 'hover']} placement="top" overlay={PopoverComponent()
          }>
            <span className="discount-info">
              <FontAwesomeIcon icon={faInfoCircle} className='fa-info-circle'/>
              Kody rabatowe
            </span>
          </OverlayTrigger>
        </span>
      </form>
      : has_recurring_payment_on === true ? 
      <>
      <h3 className="title title-thin">Płatność cykliczna kartą</h3>
      <hr />
      <p><strong>Masz włączoną cykliczną płatność kartą.</strong> Oznacza to, że gdy okres Premium się skończy, automatycznie nastąpi pobranie należności za abonament z Twojej karty płatniczej i przedłużenie ważności konta Premium.</p>
      <button onClick={changeRecurringPayment} className="btn btn-blue btn-take-out">Wyłącz płatność cykliczną kartą</button>
      <Errors errors={errors1} small={true} />
      </>
      : null
      }
    </div>
  )
}

export default Payments